module.exports = __webpack_public_path__ + "static/media/softwaredevelopment_04.dad7fce3.png";